import { defineMessages } from 'react-intl';

const scope = 'app.components.PrivacyPolicyModal';

export default defineMessages({
    cookiesTerm: {
        id: `${scope}.cookiesTerm`,
        defaultMessage:
            'This website uses cookies to improve your experience. By continuing you agree with our privacy policy and use of cookies on this site.',
    },
    linkToCookies: {
        id: `${scope}.linkToCookies`,
        defaultMessage: 'More information on our policy',
    },
    termsOfUse: {
        id: `${scope}.termsOfUse`,
        defaultMessage: 'I have read and agree to be bound by the terms of use which can be accessed <link>here</link>',
    },
    acceptButton: {
        id: `${scope}.acceptButton`,
        defaultMessage: 'Accept & Close',
    },
});
